import React, { useEffect, useState } from "react";

const CountryApp = () => {
  // Utilisation de useState pour gérer les états des données
  const [countriesData, setCountriesData] = useState([]); // Pour stocker les données des pays
  const [sortMethod, setSortMethod] = useState("alpha"); // Pour gérer la méthode de tri
  const [searchInput, setSearchInput] = useState(""); // Pour gérer la valeur de l'input de recherche
  const [rangeValue, setRangeValue] = useState(24); // Pour gérer la valeur du curseur de plage

  // Utilisation de useEffect pour effectuer une action (fetch) lors du montage du composant
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // Fetch des données des pays depuis l'API
        const response = await fetch("https://restcountries.com/v3.1/all");
        const data = await response.json();
        // Mise à jour de l'état avec les données récupérées
        setCountriesData(data);
      } catch (error) {
        console.error("Error fetching countries data:", error);
      }
    };

    fetchCountries();
  }, []);

  // Fonction de gestion du changement de l'input de recherche
  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  // Fonction de gestion du changement du curseur de plage
  const handleRangeInputChange = (event) => {
    setRangeValue(event.target.value);
  };

  // Fonction de gestion du clic sur les boutons de tri
  const handleSortButtonClick = (method) => {
    setSortMethod(method);
  };

  // Filtrage et tri des pays en fonction de l'input de recherche, du tri et de la plage
  const filteredAndSortedCountries = countriesData
    .filter((country) =>
      country.translations.fra.common
        .toLowerCase()
        .includes(searchInput.toLowerCase())
    )
    .sort((a, b) => {
      if (sortMethod === "maxToMin") {
        return b.population - a.population;
      } else if (sortMethod === "minToMax") {
        return a.population - b.population;
      } else if (sortMethod === "alpha") {
        return a.translations.fra.common.localeCompare(
          b.translations.fra.common
        );
      }
      return 0;
    })
    .slice(0, rangeValue);

  return (
    <div>
      <div className="page-container-country">
        <div className="filter-container">
          {/* Input de recherche */}
          <input
            type="text"
            id="inputSearch"
            placeholder="Rechercher"
            className="hover"
            value={searchInput}
            onChange={handleSearchInputChange}
          />
          {/* Curseur de plage */}
          <div className="range-container">
            <input
              type="range"
              placeholder="24"
              max="250"
              id="inputRange"
              className="hover"
              value={rangeValue}
              onChange={handleRangeInputChange}
            />
            <span id="rangeValue">{rangeValue}</span>
          </div>
          {/* Boutons de tri */}
          <button
            className="btn-sort hover"
            onClick={() => handleSortButtonClick("minToMax")}
          >
            Tri croissant
          </button>
          <button
            className="btn-sort hover"
            onClick={() => handleSortButtonClick("maxToMin")}
          >
            Tri décroissant
          </button>
          <button
            className="btn-sort hover"
            onClick={() => handleSortButtonClick("alpha")}
          >
            Tri Alphabétique
          </button>
        </div>

        {/* Affichage des cartes des pays */}
        <div className="countries-container">
          {filteredAndSortedCountries.map((country) => (
            <div className="card" key={country.cca3}>
              <img
                src={country.flags.svg}
                alt={country.translations.fra.common}
              />
              <h2>{country.translations.fra.common}</h2>
              <h4>{country.capital}</h4>
              <p>Population : {country.population.toLocaleString()}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountryApp;
